function goToPay() {
    console.log('open modal go to pay');
    document.querySelector('#modal-go-to-pay').style.display = 'block';
    setTimeout(() => {
        const elementToGrow = document.querySelector('.form-pay-now-background');
        elementToGrow.classList.add('grow');
        document.querySelector('.form-pay-now').style.opacity = '1';
    }, 100);
    setTimeout(() => {
        document.querySelector('.form-pay-now button').style.opacity = '1';
    }, 4000);
}

function closeModalGoToPay() {
    document.querySelector('#modal-go-to-pay').style.display = 'none';
    document.querySelector('.form-pay-now').style.opacity = '0';
    document.querySelector('.form-pay-now button').style.opacity = '0';
    const elementToGrow = document.querySelector('.form-pay-now-background');
    elementToGrow.classList.remove('grow');
}